import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const DefaultConfidentialityModeSelect = styled(Select)`
   width: 145px;
` as typeof Select;
